module.exports = __webpack_public_path__ + "static/img/img_sj@2x.de423cda.png";